import { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { Link, Route, Routes } from "react-router-dom";

// Helpers.
import Helmet from "react-helmet";

// Constants.
import { DATA_INITIALISING, DATA_LOADED, DATA_LOADING } from "../../../../component/Constants";

// APis
import IntegrationsApi from "../../../../api/Integrations";

//Types
import IntegrationType from "../../../../types/integration/IntegrationType";

// Components.
import Breadcrumb from "../../../../container/breadcrumb";
import HeaderActions from "../../../../container/header_actions";
import ConditionalRender from "../../../../helpers/ConditionalRender";

// import Detail from './Detail';
import List from "./List";
import Detail from "./Detail";


interface CoPilotProps {
    toggleMenu: Function,
    isAdmin: boolean
}

const CoPilot: React.FC<CoPilotProps> = ({ toggleMenu, isAdmin }) => {
    const [loading, setLoading] = useState<number>(DATA_INITIALISING);
    const [coPilot, setCoPilot] = useState<IntegrationType[]>([]);

    const getData = async () => {
        const coPilotData = await IntegrationsApi.getIntegrationData('ai.provider');

        setLoading(DATA_LOADED);
        setCoPilot(coPilotData);
    }

    useEffect(() => {
        if (loading === DATA_INITIALISING) {
            setLoading(DATA_LOADING);
            getData();
        }
    }, [loading]);

    /* Action Methods */
    const refresh = () => {
        setLoading(DATA_LOADING);
        getData();
    }

    return (
        <div id="content">
            <Helmet>
                <title>Co-Pilot - Settings - DBmarlin</title>
                <meta name="description" content="Manage Co-Pilot"/>
            </Helmet>

            <div id="top-header-wrapper" className="row row-cols-2">
                <Breadcrumb heading="Co-Pilot">
                    <Link to="/admin">Settings</Link>
                    <Link to="/admin/integrations">Integrations</Link>
                    <span>Co-Pilot</span>
                </Breadcrumb>
                <HeaderActions toggleMenu={toggleMenu} refresh={refresh}
                               />
            </div>

            <div className="loader">
                <ConditionalRender if={false}>
                    <div className="bar"/>
                </ConditionalRender>
            </div>

            <div className="row row-cols-1">
                <Routes>
                    <Route path="/:actionId" element={<Detail refresh={refresh} coPilot={coPilot} isAdmin={isAdmin} />}/>
                    <Route path="/" element={<List loading={loading} coPilot={coPilot} refresh={refresh} isAdmin={isAdmin}/>}/>
                </Routes>
            </div>
        </div>
    )
}

CoPilot.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired
};

export default CoPilot;
